// CacheKey c4da699513104be94b0848a902b9bea4
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  en: {
    errors: {
      messages: {
        already_confirmed: "was already confirmed, please try signing in",
        expired: "has expired, please request a new one",
        not_found: "not found",
        not_locked: "was not locked",
        not_saved: {
          one: "1 error prohibited this %{resource} from being saved:",
          other: "%{count} errors prohibited this %{resource} from being saved:"
        }
      }
    },
    devise: {
      failure: {
        already_authenticated: "You are already signed in.",
        inactive: "Your account was not yet activated.",
        invalid: "Invalid email or password.",
        invalid_token: "Invalid authentication token.",
        locked: "Your account is locked.",
        locked_out: "You have entered the incorrect password too many times and your account has been temporarily suspended. Please check your email to reset your password.",
        locked_out_user: "You have entered the incorrect password too many times and your account has been temporarily suspended. Please check your email to reset your password.",
        locked_out_admin: "You have entered the incorrect password too many times and your account has been temporarily suspended. Please contact our security team %{security_manager_email}",
        locked_out_user_reset_instructions: "We have just sent you an email with a password reset link; please use this link to reset your password, and try to login again.",
        locked_out_admin_reset_instructions: "Please contact our security team <a href=\"%{security_manager_email}\">%{security_manager_email}</a>",
        not_active: "It looks like your account has been deactivated due to inactivity. We just sent you an e-mail to reset your password - please do so in order to sign in again. If you continue to have problems, please reach out to support@cipherhealth.com",
        banned: "Your account is disabled. Please contact your administrator or support@cipherhealth.com",
        not_registered: "You need to complete the registration process in order to sign in.",
        not_found_in_database: "Invalid email or password.",
        session_limited: "Your login credentials were used in another browser. Please sign in again to continue in this browser.",
        timeout: "Your session has expired. Please sign in again to continue.",
        unauthenticated: "You need to sign in or sign up before continuing.",
        unconfirmed: "You have to confirm your account before continuing."
      },
      sessions: {
        signed_in: "Signed in successfully.",
        signed_out: "Signed out successfully."
      },
      passwords: {
        no_token: "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
        send_instructions: "You will receive an email with instructions to reset your password in a few minutes.",
        send_paranoid_instructions: "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.",
        updated: "Your password was changed successfully. You are now signed in.",
        updated_not_active: "Your password was changed successfully."
      },
      confirmations: {
        confirmed: "Your account was successfully confirmed. You are now signed in.",
        send_instructions: "You will receive an email with instructions about how to confirm your account in a few minutes.",
        send_paranoid_instructions: "If your email address exists in our database, you will receive an email with instructions about how to confirm your account in a few minutes."
      },
      registrations: {
        destroyed: "Bye! Your account was successfully cancelled. We hope to see you again soon.",
        signed_up: "Welcome! You have signed up successfully.",
        signed_up_but_inactive: "You have signed up successfully. However, we could not sign you in because your account is not yet activated.",
        signed_up_but_locked: "You have signed up successfully. However, we could not sign you in because your account is locked.",
        signed_up_but_unconfirmed: "A message with a confirmation link has been sent to your email address. Please open the link to activate your account.",
        update_needs_confirmation: "You updated your account successfully, but we need to verify your new email address. Please check your email and click on the confirm link to finalize confirming your new email address.",
        updated: "You updated your account successfully.",
        user: {
          signed_up_but_not_active: "You have signed up successfully but your account has not been approved by your administrator yet",
          signed_up_but_not_approved: "You have signed up successfully but your account has not been approved by your administrator yet"
        }
      },
      unlocks: {
        send_instructions: "You will receive an email with instructions explaining how to unlock your account in a few minutes.",
        send_paranoid_instructions: "If your account exists, you will receive an email with instructions about how to unlock it in a few minutes.",
        unlocked: "Your account has been unlocked successfully. Please sign in to continue."
      },
      omniauth_callbacks: {
        failure: "Could not authenticate you from %{kind} because \"%{reason}\".",
        success: "Successfully authenticated from %{kind} account."
      },
      mailer: {
        confirmation_instructions: {
          subject: "Confirmation instructions"
        },
        reset_password_instructions: {
          subject: "Reset password instructions"
        },
        unlock_instructions: {
          subject: "Unlock Instructions"
        }
      }
    }
  }
}

